import { ContentSettingsContext } from './content-settings.context';
import { useContext } from 'react';

export const useContentSettings = () => {
    const context = useContext(ContentSettingsContext);
    if (!context) {
        throw new Error('useContentSettings must be used within a ContentSettingsProvider');
    }
    return context;
};
